import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { HfDynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import GrandScore from './grand-score.component';

interface GrandScoreValue {
  totalScore: number;
  maxPossible: number;
  percentage: string;
}

export interface HfGrandScoreProps<TFieldValues extends FieldValues = FieldValues>
  extends HfDynamicFieldComponentProps<GrandScoreValue, undefined, TFieldValues> {
  control: Control<TFieldValues>;
}

export default function HfGrandScore<TFieldValues extends FieldValues = FieldValues>({
  control,
  label,
  name,
  readOnly,
  labelStyles,
}: HfGrandScoreProps<TFieldValues>) {
  return (
    <Controller
      name={name as FieldPath<TFieldValues>}
      control={control}
      render={({ field: { value } }) => (
        <GrandScore
          label={label}
          readOnly={readOnly}
          totalScore={value?.totalScore}
          maxPossible={value?.maxPossible}
          percentage={value?.percentage}
          labelStyles={labelStyles}
        />
      )}
    />
  );
}
